/**
 * Tasks module constants (Tasks Module PRD).
 */

export const TASK_COLUMNS = [
  { key: 'meeting', emoji: '📅', label: 'Meeting' },
  { key: 'discussed', emoji: '🚀', label: 'Discussed' },
  { key: 'working', emoji: '🏢', label: 'Working' },
  { key: 'done', emoji: '✅', label: 'Done' },
  { key: 'storage', emoji: '📦', label: 'Storage' }
];

export const TASK_PRIORITIES = ['Low', 'Medium', 'High', 'Critical'];

export const PRIORITY_COLORS = {
  Low: '#9e9e9e',
  Medium: '#1976d2',
  High: '#ed6c02',
  Critical: '#d32f2f'
};

export const TASK_VISIBILITY = {
  COMPANY: 'company',
  PRIVATE: 'private'
};

// Sentinel for the "tasks with no client" filter value
export const NO_CLIENT = '__NONE__';

// Persisted per user in users.taskFilters; client is null | NO_CLIENT | clientId
export const DEFAULT_TASK_FILTERS = {
  status: 'incomplete',
  visibility: 'all',
  assignee: 'all',
  client: null
};

export const normalizeTaskFilters = (raw) => {
  const filters = { ...DEFAULT_TASK_FILTERS };
  if (!raw || typeof raw !== 'object') return filters;
  if (['incomplete', 'completed', 'all'].includes(raw.status)) filters.status = raw.status;
  if (['all', 'company', 'private'].includes(raw.visibility)) filters.visibility = raw.visibility;
  if (['all', 'me', 'unassigned'].includes(raw.assignee)) filters.assignee = raw.assignee;
  if (raw.client === null || typeof raw.client === 'string') filters.client = raw.client;
  return filters;
};
